/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { closeTicket } from '../../actions/TicketActions';
import { closeConversation } from '../../actions/ConversationActions';
import { useAppDispatch, useAppSelector } from '../../reducers/zorseGrrTagging';
import { jsx as _jsx } from "react/jsx-runtime";
function isResolutionDisabled(ticket, productAreaToRoadblocks, isCloseTicketChecked) {
  if (isCloseTicketChecked) {
    return !ticket.isResolvable(productAreaToRoadblocks);
  } else {
    return !ticket.isAlmostResolvable(productAreaToRoadblocks);
  }
}
function MarkAsClosedButton(props) {
  const dispatch = useAppDispatch();
  const actionStates = useAppSelector(({
    zorseGrrTagging: state
  }) => state.actionStates);
  const isCloseTicketChecked = useAppSelector(({
    zorseGrrTagging: state
  }) => state.panelState.closeTicketCheckedByTicketId.get(state.ticket.id, true));
  const productAreaToRoadblocks = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticketExternalProperties.productAreaToRoadblocksMapping);
  const ticket = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticket);
  return /*#__PURE__*/_jsx(UILoadingButton, {
    "data-test-id": "loading-button-test-id",
    disabled: !actionStates.couldNotFindTicket && (actionStates.isEditingSubject || actionStates.isSaving || isResolutionDisabled(ticket, productAreaToRoadblocks, isCloseTicketChecked)),
    loading: actionStates.isClosingConversation || actionStates.isClosingTicket,
    onClick: () => {
      if (!actionStates.couldNotFindTicket && isCloseTicketChecked) {
        dispatch(closeTicket(ticket.id));
      }
      dispatch(closeConversation(ticket.conversationId)).then(() => props.onResolved()).catch(() => {});
    },
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.panel.footer.buttons.markAsClosed"
    })
  });
}
MarkAsClosedButton.propTypes = {
  onResolved: PropTypes.func.isRequired
};
export default MarkAsClosedButton;